const FollowUp = () => import('./pages/follow_up')
const PreviewAssignors = () => import('./components/preview-assignors')
const PreviewAssignments = () => import('./components/preview-assignments')

const LimitIndex = () => import('./pages/limits')
const LimitAssignors = () => import('./components/limit-assignors')
const LimitPayers = () => import('./components/limit-payers')

export default [
  {
    path: '/follow_up',
    component: FollowUp,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'assignors',
        name: 'preview.assignors',
        component: PreviewAssignors,
        meta: { requiresAuth: true }
      },
      {
        path: 'assignments',
        name: 'preview.assignments',
        component: PreviewAssignments,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/follow_up/limits',
    component: LimitIndex,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'payers',
        name: 'limits.payers',
        component: LimitPayers,
        meta: { requiresAuth: true }
      },
      {
        path: 'assignors',
        name: 'limits.assignors',
        component: LimitAssignors,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/follow_up/routes.js